import _ from "lodash";
import { UNIFORM_RESOURCE_LOCATORS } from "./constants";
//  all possible actions on a model
const VIEW_PERM = "view";
const ALL_PERM = "all";
// All the models that ave permissions enforced (should be updated if new models are added)
const PAYMENT_MODEL = "payment";
const INVOICE_MODEL = "invoice";
const UTILITY_MODEL = "unitutility";
const TENANT_MODEL = "tenant";
const PROPERTY_MODEL = "property";
const UNIT_MODEL = "unit";
const MESSAGE_MODEL = "message";
const ALL_MODELS = [
  PAYMENT_MODEL,
  INVOICE_MODEL,
  UTILITY_MODEL,
  TENANT_MODEL,
  PROPERTY_MODEL,
  UNIT_MODEL,
  MESSAGE_MODEL,
];
const ALL_PERMS = [VIEW_PERM, ALL_PERM];


// this is useful to prevent brute force access to the pages
const URL_MODEL_PERM_MAP: any = {
    // payments
    [UNIFORM_RESOURCE_LOCATORS.payments]: {model: PAYMENT_MODEL, perm: VIEW_PERM},
    // invoices
    [UNIFORM_RESOURCE_LOCATORS.invoices]: {model: INVOICE_MODEL, perm: VIEW_PERM},
    [UNIFORM_RESOURCE_LOCATORS.invoiceForm]: {model: INVOICE_MODEL, perm: ALL_PERM},
    // reports (view requires invoice or payment view, reuse invoice model)
    [UNIFORM_RESOURCE_LOCATORS.reports]: {model: INVOICE_MODEL, perm: VIEW_PERM},
    // tenants
    [UNIFORM_RESOURCE_LOCATORS.tenants]: {model: TENANT_MODEL, perm: VIEW_PERM},
    [UNIFORM_RESOURCE_LOCATORS.tenantForm]: {model: TENANT_MODEL, perm: ALL_PERM},
    [UNIFORM_RESOURCE_LOCATORS.tenantTransactions]: {model: TENANT_MODEL, perm: VIEW_PERM},
    // utilities
    [UNIFORM_RESOURCE_LOCATORS.utilities]: {model: UTILITY_MODEL, perm: VIEW_PERM},
    // units
    [UNIFORM_RESOURCE_LOCATORS.units]: {model: UNIT_MODEL, perm: VIEW_PERM},
    [UNIFORM_RESOURCE_LOCATORS.unitForm]: {model: UNIT_MODEL, perm: ALL_PERM},
    // properties
    [UNIFORM_RESOURCE_LOCATORS.properties]: {model: PROPERTY_MODEL, perm: VIEW_PERM},
    [UNIFORM_RESOURCE_LOCATORS.propertyForm]: {model: PROPERTY_MODEL, perm: ALL_PERM},
};

const PAGES_TO_CHECK = Object.keys(URL_MODEL_PERM_MAP)

function checkUserHasPermission(model: string, perm: string, userPermissions:any[]) {
  if (!ALL_MODELS.includes(model) || !ALL_PERMS.includes(perm)) {
    return true;
  }
  if (_.isEmpty(userPermissions)) {
    return false;
  }
  let permModel = userPermissions.find((perm: any) => perm.model === model);

  if (perm === VIEW_PERM) {
    return permModel[VIEW_PERM] || permModel[ALL_PERM];
  } else {
    return permModel[ALL_PERM];
  }
}

export {
  checkUserHasPermission,
  VIEW_PERM,
  ALL_PERM,
  PAYMENT_MODEL,
  INVOICE_MODEL,
  UTILITY_MODEL,
  TENANT_MODEL,
  PROPERTY_MODEL,
  UNIT_MODEL,
  MESSAGE_MODEL,
  URL_MODEL_PERM_MAP,
  PAGES_TO_CHECK
};
